var React = require('react');

function BlobRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"blob__body","d":"M133.391 229.998C154.784 228.858 174.464 217.94 186.755 200.392L248.779 111.841C270.856 80.3216 263.202 36.8729 231.682 14.7958C200.163 -7.28138 156.714 0.373153 134.637 31.8927L123.671 47.5478L40.3528 164.021L77.1828 206.229C91.2684 222.372 111.997 231.137 133.391 229.998Z","fill":"#FFB6AB","key":0}),React.createElement("path",{"className":"blob__face","d":"M193.676 33.154C191.962 43.1321 201.56 48.0065 208.337 43.7251M216.04 48.6263C214.326 58.6044 223.925 63.4787 230.702 59.1974M179.498 44.6049C182.41 73.6423 202.78 82.5942 226.764 71.9121","stroke":"#FF553C","strokeWidth":"4.92264","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BlobRight.defaultProps = {"width":"267","height":"234","viewBox":"0 0 267 234","fill":"none"};

module.exports = BlobRight;

BlobRight.default = BlobRight;
